// extracted by mini-css-extract-plugin
export default {"r_l":"cb0f6f9783 _0dbaa3a26c","t":"_14e7ae2c24"};